import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';

import { OnboardingChecklistComponent } from './onboarding-checklist.component';
import { FloatingChecklistComponent } from './floating-checklist/floating-checklist.component';
import { OnboardingChecklistService } from './onboarding-checklist.service';
import { JourneyContactPhoneStripComponent } from './journey-contact-phone-strip/journey-contact-phone-strip.component';
import { ExampleWorkdayComponent } from '../example-workday/example-workday.component';
import { ExampleProductivityTrendsPreviewComponent } from '../example-workday/example-productivity-trends-preview.component';
import { WhatYouControlComponent } from '../example-workday/previews/what-you-control.component';
import { JourneyAssistedSetupDialogComponent } from './journey-assisted-setup-dialog/journey-assisted-setup-dialog.component';

@NgModule({
  declarations: [
    OnboardingChecklistComponent,
    FloatingChecklistComponent,
    ExampleWorkdayComponent,
    ExampleProductivityTrendsPreviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatTooltipModule,
    MatSelectModule,
    JourneyContactPhoneStripComponent,
    JourneyAssistedSetupDialogComponent,
    WhatYouControlComponent,
  ],
  exports: [
    OnboardingChecklistComponent,
    FloatingChecklistComponent,
    ExampleWorkdayComponent,
  ],
  providers: [
    OnboardingChecklistService
  ]
})
export class OnboardingChecklistModule { }
